import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { ComboService } from './combo.service';
import { Combo2Service } from './combo2.service';
import { SalesPlanService } from './salesplan.service';
import { SeasonService } from './season.service';
import { FinyearService } from './finyear.service';
import { UserService } from './userlist.service';
import { SharedService } from './shared.service';
import { DesignphotoService } from './designphoto.service';
import { DesignMaster } from './designmaster.service';
import { DesignService } from './designlist.service';
import { ReportService } from './report.service';
import { MenuMappingService} from './menuMapping.service';
import { DesignData } from './designdata.service';
import { ExcelService } from './excel.service';
import { InvoiceService } from './invoice.service';
import { PurchaseOrderService } from './purchaseorder.service';
import { POCancelService } from './poCancel.service';
import { LorryService } from './lorry.service';
import { GrnService } from './grn.service';
import { ReturnService } from './return.service';
import { PurchaseStockService } from './purchasestock.service';
import { PurchaseReportService } from './purchasereport.service';
import { DCService } from './dc.service';
import { SampleService } from './sample.service';
import { WorkOrderService } from './workorder.service';
import { WorkOrderReportService } from './workorderreport.service';
import { ActualCuttingService } from './actualcutting.service';
import { rgrnService } from './rgrn.service';
import { CostService } from './cost.service';
import { SwatchService } from './swatch.service';
import { SalesOrderService } from './salesOrder.service';
import { SalesReturnService } from './salesReturn.service';
import {SalesReplacementService} from './salesReplacement.service';
import { StockService } from './stock.service';
import { SaleSampleService } from './salesample.service';
import { SaleDC } from './salesDc.service';
import { PartyService } from './party.service';
import { SalesInvoiceService } from './salesinvoice.service';
import { LrUpdateService } from './lrupdate';
import { JGRNService } from './jgrn.service';
import { HyattEvent} from './events.services';
import { agentOutwardService } from './agentoutward.service';
import { EstiWorkOrderService } from './estiworkorder.service';
import { JobWorkService } from './jobwork.service';

import { barcodeDesignHistory } from './barcodeDesignHistory.service';
import { WhWorkOrderService } from './whWorkOrder.service';



export const APP_PROVIDERS: any[] = [
	DesignData,
	CommonService,
	MenuMappingService,
	ReportService,
	DesignMaster,
	Combo2Service,
	AuthService,
	ComboService,
	SalesPlanService,
	SeasonService,
	FinyearService,
	DesignphotoService,
	UserService,
	SharedService,
	DesignService,
	ExcelService,
	InvoiceService,
	PurchaseOrderService,
	POCancelService,
	LorryService,
	GrnService,
	ReturnService,
	PurchaseStockService,
	PurchaseReportService,
	DCService,
	SampleService,
	WorkOrderService,
	WhWorkOrderService,
	ActualCuttingService,
	rgrnService,
	CostService,
	SwatchService,
	SalesOrderService,
	SalesReturnService,
	SalesReplacementService,
	StockService,
	SaleSampleService,
	SaleDC,
	PartyService,
	SalesInvoiceService,
	LrUpdateService,
	JGRNService,
	HyattEvent,
	WorkOrderReportService,
	agentOutwardService,
	EstiWorkOrderService,
	JobWorkService,
	barcodeDesignHistory
]
export * from './rgrn.service'
export *  from './designdata.service';
export * from './combo2.service';
export * from './report.service';
export * from './designlist.service';
export * from './designmaster.service';
export * from './auth.service';
export * from './designphoto.service';
export * from './common.service';
export * from './combo.service';
export * from './salesplan.service';
export * from './season.service';
export * from './finyear.service';
export * from './userlist.service';
export * from './shared.service';
export * from './menuMapping.service';
export * from './excel.service';
export * from './invoice.service';
export * from './purchaseorder.service';
export * from './poCancel.service';
export * from './lorry.service';
export * from './grn.service';
export * from './return.service';
export * from './purchasestock.service';
export * from './purchasereport.service';
export * from './dc.service';
export * from './sample.service';
export * from './workorder.service';
export * from './actualcutting.service';
export * from './cost.service';
export * from './swatch.service';
export * from './salesOrder.service';
export * from './salesReturn.service';
export * from './salesReplacement.service';
export * from './stock.service';
export * from './salesample.service';
export * from './salesDc.service';
export * from './party.service';
export * from './salesinvoice.service';
export * from './lrupdate';
export * from './jgrn.service';
export * from './events.services';
export * from './workorderreport.service';
export * from './agentoutward.service';
export * from './estiworkorder.service';
export * from './barcodeDesignHistory.service';
export * from './jobwork.service';











// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/index.ts